import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as DetectionActions from '../../actions/Detection.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import leftEar from '../../static/images/left-ear.png';
import LevelBar from '../../components/LevelBar.js';
import LeftVolume from '../../static/images/volume-left.png';
import Helpers from '../../helpers';

const AudioContext = window.webkitAudioContext || window.AudioContext;
let context = AudioContext ? new AudioContext() : null;
let timeout;
// Hz Array
const soundHz = [4000, 2000, 500, 1000];

const styles = {
  wrap: {
    maxWidth: 720,
    margin: '70px auto 0px auto',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      margin: '10px auto 0px auto',
    },
  },
  wrap_TV: {
    width: '90%',
    margin: '70px auto 0px',
    textAlign: 'center',
  },
  placement: {
    display: 'flex',
    paddingBottom: 40
  },
  container: {
    flex: 1,
    backgroundColor: 'transparent',
    display: 'block',
    height: 320,
    '@media (max-width: 767px)': {
      height: 'initial',
    }
  },
  container_TV : {
    flex: 1,
    backgroundColor: 'transparent',
    display: 'block',
    height: '100%'
  },
  imageWrapper: {
    position: 'relative',
  },
  image: {
    height: 192,
    '@media (max-width: 767px)': {
      height: 132,
    },
  },
  image_TV: {
    height: 350,
  },
  movieMode: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '24px 0',
  },
  movieModeToggle: {
    backgroundColor: '#fed312',
    width: 260,
    height: 42,
    borderRadius: 3,
    margin: '0 29px',
    border: 0,
    fontSize: 18,
    color: '#fff',
    fontWeight: 100,
    letterSpacing: 4,
    padding: '0 0 0 4px',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
    '@media (max-width: 767px)': {
      margin: '0px 10px',
    }
  },
  movieModeToggle_TV: {
    backgroundColor: '#fed312',
    width: '40%',
    height: 80,
    borderRadius: 5,
    margin: '0 29px',
    border: 0,
    fontSize: 35,
    color: '#fff',
    fontWeight: 100,
    letterSpacing: 4,
    padding: '0 0 0 4px',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  reverseColor: {
    backgroundColor: '#f87c7f',
  },
  word: {
    fontSize: 18,
    display: 'block',
    color: '#4f4f4f',
    padding: '5px 0'
  },
  word_TV: {
    fontSize: 35,
    display: 'block',
    color: '#4f4f4f',
    padding: '5px 0',
  },
  linkIcon: {
    fontSize: 30,
    padding: '6px 0',
    '@media (max-width: 767px)': {
      fontSize: 15,
    }
  },
  linkIcon_TV: {
    fontSize: 38,
    padding: '6px 0',
  },
  linkText: {
    fontSize: 20,
    fontWeight: 'bold',
    '@media (max-width: 767px)': {
      fontSize: 15,
    }
  },
  linkText_TV: {
    fontSize: 28,
    fontWeight: 'bold',
  },
  feq: {
    fontSize: 48,
    margin: '20px 0 0 0',
    color: '#4f4f4f',
    display: 'block',
  },
  grayColor: {
    backgroundColor: '#9B9B9B',
  },
  fixedBlock: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: '#9B9B9B',
    textAlign: 'center',
  },
  textFixed: {
    position: 'absolute',
    top: 'calc(50% - 50px)',
    left: 'calc(50% - 60px)',
  },
  volume: {
    width: 99,
    height: 86,
    position: 'absolute',
    top: 70,
    left: 140,
    '@media (max-width: 767px)': {
      width: 45,
      height: 43,
      top: 60,
      left: 30,
    },
  },
  volume_TV: {
    width: 150,
    position: 'absolute',
    top: 140,
    left: 200,
  },
  fadeout: {
    color: '#ccc',
  },
};

class DetectionTestLeftPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      level: 1,
      audioNode: null,
      firstTime: true,
    };
  }

  componentDidMount() {
    this.playSound();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.level !== this.state.level && this.state.playing && prevProps.stepKey === this.props.stepKey) {
      this.playSound();
    }
    if (prevProps.stepKey !== this.props.stepKey) {
      if (this.state.audioNode) {
        this.state.audioNode.stop();
      }
      this.playSound();
    }
  }

  changeSampleRate() {
    if (timeout) clearTimeout(timeout);
    if (this.state.firstTime) this.setState({ firstTime: false });
    if (/(iPhone|iPad)/i.test(navigator.userAgent)) {
      const buffer = context.createBuffer(1, 1, 44100);
      const dummy = context.createBufferSource();
      dummy.buffer = buffer;
      dummy.connect(context.destination);
      dummy.start(0);
      dummy.disconnect();
      timeout = setTimeout(() => {
        context.close(); // dispose old context
        context = new AudioContext();
      }, 3000);
    }
  }

  resetNode() {
    this.setState({
      audioNode: null,
    });
  }

  resetLevel() {
    this.setState({
      level: 1,
    });
  }

  addLevel(level, seqNum, count) {
    if (level <= 5) {
      this.setState({
        level: this.state.level + 1,
      });
    } else {
      const {
        setLeftAnswer,
      } = this.props;

      setLeftAnswer(level, seqNum, count);
      this.resetLevel();
      if (this.state.audioNode) {
        this.state.audioNode.stop();
        this.resetNode();
      }
    }
  }

  minusLevel() {
    if (this.state.level > 1) {
      this.setState({
        level: this.state.level - 1,
      });
    }
  }

  async playSound() {
    if (!context) {
      return alert('此功能不支援您的瀏覽器！');
    }

    const {
      level,
    } = this.state;

    const {
      testList,
      soundList,
      stepKey,
    } = this.props;

    const activedSpec = testList.find(s => s.key === stepKey);
    const index = soundHz.findIndex((feq) => (feq === activedSpec.frequency));
    const rule = soundList[index];
    const key = Object.keys(rule).find((db) => (
      parseInt(db, 10) === (20 + (level - 1) * 10)
    ));

    if (this.state.audioNode && this.state.playing) {
      this.state.audioNode.stop();
    }

    fetch(rule[key])
      .then(response => response.arrayBuffer())
      .then(response => context.decodeAudioData(response, audioBuffer => {
        // Play Audio
        const source = context.createBufferSource();
        source.buffer = audioBuffer;

        source.connect(context.destination);

        this.setState({
          audioNode: source,
          playing: true,
        });

        this.state.audioNode.start(0);
      })
    );

    return true;
  }

  submitAnswer(level, seqNum, count) {
    this.changeSampleRate();
    const {
      setLeftAnswer,
    } = this.props;

    setLeftAnswer(level, seqNum, count);
    this.resetLevel();
    if (this.state.audioNode) {
      this.state.audioNode.stop();
      this.resetNode();
    }
  }

  render() {
    const {
      testList,
      stepKey,
      count,
    } = this.props;

    const {
      level,
      firstTime,
    } = this.state;

    const activedSpec = testList.find(s => s.key === stepKey);
    const seqNum = parseInt(stepKey, 10);
    const isMiniumLevel = level === 1;

    if (!activedSpec) return <div style={styles.wrap}></div>;

    if (/(iPhone|iPad)/i.test(navigator.userAgent) && firstTime) {
      return (
        <div style={styles.fixedBlock} onTouchEnd={() => this.changeSampleRate()}>
          <span style={styles.textFixed}>請按此處開始播放</span>
        </div>
      );
    }

    var wrap = styles.wrap;
    var container = styles.container;
    var movieModeToggle = styles.movieModeToggle;
    var word = styles.word;
    var linkIcon = styles.linkIcon;
    var linkText = styles.linkText;
    var image = styles.image;
    var volume = styles.volume;

    if (Helpers.Session.isViaTV()) {
      wrap = styles.wrap_TV;
      container = styles.container_TV;
      movieModeToggle = styles.movieModeToggle_TV;
      word = styles.word_TV;
      linkIcon = styles.linkIcon_TV;
      linkText = styles.linkText_TV;
      image =styles.image_TV;
      volume = styles.volume_TV;
    } 

    return (
      <div style={wrap}>
        <div style={styles.placement}>
          <LevelBar level={level} />
          <div style={container}>
            <div style={styles.imageWrapper}>
              <img style={image} src={leftEar} role="presentation" />
              <img style={volume} src={LeftVolume} role="presentation"></img>
            </div>
            <span style={styles.feq}>{activedSpec.frequency} Hz</span>
            <span style={word}>音頻正播放於您的左耳</span>
            <span style={word}>當您聽到聲音時請按鈕</span>
          </div>
        </div>
        <div style={styles.movieMode}>
          <button
            type="button"
            onClick={() => this.submitAnswer(level, seqNum, count)}
            style={[movieModeToggle]}>
            <span style={linkIcon} className="fa fa-circle-thin" />
            <span style={linkText}>是</span></button>
          <button
            type="button"
            onClick={() => this.addLevel(level, seqNum, count)}
            onTouchEnd={() => this.changeSampleRate()}
            style={[movieModeToggle, styles.reverseColor]}>
            <span style={linkIcon} className="fa fa-times" />
            <span style={linkText}>否</span></button>
        </div>
        <div style={styles.movieMode}>
          <button
            type="button"
            onClick={() => { if (!isMiniumLevel) this.minusLevel()}}
            style={[movieModeToggle, styles.grayColor]}>
            <span style={linkIcon} className="fa fa-chevron-left" />
            <span style={[linkText, isMiniumLevel && styles.fadeout]}>上一個強度</span></button>
          <button
            type="button"
            onClick={() => this.playSound()}
            style={[movieModeToggle, styles.grayColor]}>
            <span style={linkIcon} className="fa fa-refresh" />
            <span style={linkText}>再聽一次</span></button>
        </div>
      </div>
    );
  }
}

DetectionTestLeftPlayer.propTypes = {
  testList: T.arrayOf(T.shape({
    key: T.number,
    frequency: T.number,
  })),
  soundList: T.array,
  stepKey: T.number,
  count: T.number,
  leftResult: T.array,
  setLeftAnswer: T.func,
};

export default connect(
  state => ({
    testList: state.Detection.testList,
    soundList: state.Detection.leftSoundList,
    leftResult: state.Detection.leftResult,
  }),
  dispatch => bindActionCreators(DetectionActions, dispatch),
)(radium(DetectionTestLeftPlayer));



// WEBPACK FOOTER //
// ./containers/Detections/DetectionTestLeftPlayer.js